import moment from "moment";
import * as Yup from "yup";
export const postiveNagtiveRadio = [
    { value: 0, label: "Postive" },
    { value: 1, label: "Negative" },
]

export const appearanceRadio = [
    { value: 0, label: "Yes" },
    { value: 1, label: "No" },
]

const requiredIfNotDraft = (schema, message, isDraft) =>
  isDraft ? schema.notRequired() : schema.required(message);


export const validationSchemaCOAComment = Yup.object().shape({
    comment: Yup.string()
        .required("Comment is required")
        .max(200, "Enter less than 200 characters"),
});

export const coaFormValues = {
    storage_condition: "-80±10°C",
    specification_no: "SPC/C01/CT/01-00",
    rcl_qpcr: '',
    sterility_culture_method_bactec: '',
    multiplex_viral_test_pcr: '',
    mycoplasma_pcr: '',
    appearance: '',
    car_surface_expression_flow_cytometry: null,
    cell_viability_dye_exclusion_method: null,
    cd19_viable_cell_detection_flow_cytometry: null,
    detection_of_magnetic_beads_microscope: "",
    endotoxin_level: null,
    vector_copy_number_vcn_qpcr: null,
    remarks: "",
    lead_remarks: "",
    qa_remarks:""
}



export const coaFormValidationSchema = (
  qcLeadRemark = false,
  canShowQaRemarks = false,
  isDraft = false
) => {
  return Yup.object().shape({

    batch_no: requiredIfNotDraft(
      Yup.string().max(50, "Batch No cannot exceed 50 characters"),
      "Batch No is required",
      isDraft
    ),

    storage_condition: requiredIfNotDraft(
      Yup.string(),
      "Storage Condition is required",
      isDraft
    ),

    specification_no: requiredIfNotDraft(
      Yup.string(),
      "Specification No is required",
      isDraft
    ),

    rcl_qpcr: requiredIfNotDraft(
      Yup.string()
        .typeError("RCL qPCR result is required")
        .nullable(),
      "RCL qPCR result is required",
      isDraft
    ),

    sterility_culture_method_bactec: requiredIfNotDraft(
      Yup.string()
        .typeError("Sterility Culture result is required")
        .nullable(),
      "Sterility Culture result is required",
      isDraft
    ),

    multiplex_viral_test_pcr: requiredIfNotDraft(
      Yup.string()
        .typeError("Multiplex Viral Test result is required")
        .nullable(),
      "Multiplex Viral Test result is required",
      isDraft
    ),

    mycoplasma_pcr: requiredIfNotDraft(
      Yup.string()
        .typeError("Mycoplasma PCR result is required")
        .nullable(),
      "Mycoplasma PCR result is required",
      isDraft
    ),

    appearance: requiredIfNotDraft(
      Yup.string()
        .typeError("Appearance is required")
        .nullable(),
      "Appearance is required",
      isDraft
    ),

    car_surface_expression_flow_cytometry: requiredIfNotDraft(
      Yup.number()
        .typeError("CAR Surface Expression must be a number")
        .min(0, "Must be ≥ 0")
        .nullable(),
      "CAR Surface Expression is required",
      isDraft
    ),

    cell_viability_dye_exclusion_method: requiredIfNotDraft(
      Yup.number()
        .typeError("Cell Viability must be a number")
        .min(0, "Must be ≥ 0")
        .nullable(),
      "Cell Viability is required",
      isDraft
    ),

    cd19_viable_cell_detection_flow_cytometry: requiredIfNotDraft(
      Yup.number()
        .typeError("CD19 Viable Cell Detection must be a number")
        .min(0, "Must be ≥ 0")
        .nullable(),
      "CD19 Viable Cell Detection is required",
      isDraft
    ),

    detection_of_magnetic_beads_microscope: requiredIfNotDraft(
      Yup.string().nullable(),
      "Magnetic Beads Detection is required",
      isDraft
    ),

    endotoxin_level: requiredIfNotDraft(
      Yup.string()
        .nullable(),
      "Endotoxin Level is required",
      isDraft
    ),

    vector_copy_number_vcn_qpcr: requiredIfNotDraft(
      Yup.number()
        .typeError("Vector Copy must be a number")
        .min(0, "Must be ≥ 0")
        .nullable(),
      "Vector Copy Number is required",
      isDraft
    ),

    remarks: requiredIfNotDraft(
      Yup.string().nullable(),
      "Remarks are required",
      isDraft
    ),

    ...(qcLeadRemark
      ? {
          lead_remarks: requiredIfNotDraft(
            Yup.string().nullable().trim(),
            "Remarks are required",
            isDraft
          ),
        }
      : {}),

    ...(canShowQaRemarks
      ? {
          qa_remarks: requiredIfNotDraft(
            Yup.string().nullable().trim(),
            "Remarks are required",
            isDraft
          ),
        }
      : {}),

    expired_at: requiredIfNotDraft(
      Yup.date()
        .transform((value, originalValue) => {
          if (value instanceof Date && !isNaN(value)) return value;
          const parsed = moment(originalValue, "DD/MM/YYYY", true);
          return parsed.isValid() ? parsed.toDate() : new Date("");
        })
        .typeError("Expiry Date must be a valid date (DD/MM/YYYY)"),
      "Expiry Date is required",
      isDraft
    ),
  });
};

